<template>
  <div>
    <v-card @click.native="inputFile"
      class="scroll-y">
      <v-card-text style="height: 75%">
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex v-for="file in files" :key="file.name" xs12 sm6 md4 lg3>
              <UploadPreview 
                @remove="removeFile"
                @uploaded="fileUploaded"
                ref="previews"
                :file="file" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <input 
        v-show="false" 
        ref="input"
        accept="image/*"
        type="file"
        multiple
        @change="fileSelected">
    </v-card>
  </div>
</template>

<script>
import UploadPreview from '@/components/upload/UploadPreview';

export default {
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      rowsPerPageItems: [10, 20, 30],
      pagination: {
        rowsPerPage: 20,
      },
    };
  },
  methods: {
    inputFile() {
      this.$refs.input.click();
    },
    uploadAll() {
      this.$refs.previews.forEach(preview => preview.upload());
    },
    addFile(file) {
      this.$emit('fileAdded', file);
    },
    removeFile(file) {
      this.$emit('fileRemoved', file);
    },
    fileUploaded(file) {
      this.$emit('fileUploaded', file);
    },
    fileSelected(event) {
      for (let i = 0; i < event.target.files.length; i+=1) {
        const file = event.target.files[i];
        this.addFile(file)
      }
      this.$refs.input.value = "";
    },
  },
  components: {
    UploadPreview,
  },
};
</script>